import { FC, useContext } from 'react'
import { Container, Button, Row, Col, Divider } from '@mch-group/uikit-components'
import { getSiteLanguage } from '@utils/storage'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import { Text } from '@components'
import { scrollToElement } from '@utils/scroll'
import { LoginContext } from '@providers/Login'

interface IPressAccLogin {
  className?: string
  mpal_description: string
}

const PressAccreditationLogin: FC<IPressAccLogin> = (props) => {
  const { labels } = useLabelsFromAPI(['SignIn', 'Access'], getSiteLanguage())
  const { showLogin, user } = useContext(LoginContext)

  const isLoggedIn = user.loginData && true

  const loginFormCallback = () => {
    setTimeout(() => {
      scrollToElement('press-accreditation-profile')
    }, 1000)
  }

  return !isLoggedIn && labels ? (
    <Container className={`${props.className} px-5 px-lg-8 px-md-7 mb-10`}>
      <Divider color='mch-gray-200' size='m' className='mb-0' />
      <Row gutter='g-5 g-md-6 g-xl-7'>
        <Col xs={12} md={12} lg={6}>
          <h2 className='mt-8 mt-md-9 mb-5 mb-md-6 h3'>{labels['SignIn']?.loginTitleLabel}</h2>
        </Col>
      </Row>
      <Row gutter='g-5 g-md-6 g-xl-7'>
        <Col xs={12} md={12} lg={12} xl={6}>
          <Text isHtml>{props.mpal_description}</Text>
          <Row gutter='g-5 g-md-6 g-xl-7'>
            <Col xs={12} md={12} lg={6}>
              <Button
                className='login-button mt-5'
                onClick={() =>
                  showLogin({
                    onLoginSuccessCallback: () => {
                      loginFormCallback()
                    }
                  })
                }
              >
                {labels['Access']?.loginOrRegisterBtnLabel}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  ) : null
}

export default PressAccreditationLogin